module.exports = __webpack_public_path__ + "img/200.8595b745.png";